<nb-card style="width: 400px; max-width: 95vw; height: 700px; max-height: 90vh; display: flex; flex-direction: column;"
    (click)="$event.stopPropagation()">
    <nb-card-header>Choisir mes catégories</nb-card-header>
    <nb-card-body style="overflow-y: auto;">
        <div style="margin-bottom: 20px;">
            <label class="label"
                style="display: block; margin-bottom: 0.5rem; color: #8f9bb3; font-family: 'Inter', sans-serif; font-size: 0.75rem; font-weight: 700; text-transform: uppercase;">Groupe
                de catégories</label>
            <select [ngModel]="selectedMetaId" (ngModelChange)="onMetaChange($event)"
                style="width: 100%; padding: 0.75rem 1rem; border-radius: 0.25rem; border: 1px solid #e4e9f2; background-color: #f7f9fc; color: #222b45; font-family: 'Inter', sans-serif; font-size: 0.9375rem; appearance: none; -webkit-appearance: none; cursor: pointer;">
                <option *ngFor="let meta of metaCategories" [value]="meta.id">{{ meta.label }}</option>
            </select>
        </div>

        <div style="margin-bottom: 12px; position: relative;">
            <input type="text" [ngModel]="searchTerm" (ngModelChange)="onSearchChange($event)"
                placeholder="Rechercher une catégorie…"
                style="width: 100%; padding: 0.6rem 2rem 0.6rem 0.85rem; border-radius: 0.25rem; border: 1px solid #e4e9f2; background-color: #f7f9fc; color: #222b45; font-family: 'Inter', sans-serif; font-size: 0.875rem;" />
            <span class="search-spinner" [style.visibility]="filtering ? 'visible' : 'hidden'"></span>
        </div>

        <div [nbSpinner]="loading" nbSpinnerStatus="danger" nbSpinnerSize="medium" style="min-height: 100px;">
            <nb-list>
                <nb-list-item *ngFor="let cat of filteredCategories; trackBy: trackById">
                    <nb-checkbox status="danger" [checked]="tempSelectedIds.has(cat.id)"
                        (checkedChange)="toggleSelection(cat.id, $event)">
                        {{ cat.label }}
                    </nb-checkbox>
                </nb-list-item>
                <nb-list-item *ngIf="!loading && filteredCategories.length === 0"
                    style="color: #8f9bb3; font-style: italic;">
                    Aucune catégorie ne correspond
                </nb-list-item>
            </nb-list>
        </div>
    </nb-card-body>
    <nb-card-footer style="display: flex; justify-content: flex-end; gap: 10px;">
        <button nbButton status="basic" (click)="cancel()">Annuler</button>
        <button nbButton status="danger" (click)="submit()">Valider</button>
    </nb-card-footer>
</nb-card>